import React, { Component, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import AppAppBar from "./app.app.bar";
import HeroContent from './hero.content';
import PackCard from './pack.card';
import PackDescription from './pack.description';
import PackBuilder from './pack.builder';
import data from '../data/packs';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from '../modules/theme';
import { connect } from 'react-redux';
import { 
  selectBasePack,
  selectBaseOption,
  selectAddOn, 
  removeBasePack, 
  removeBaseOption, 
  removeAddOn
} from '../store/pack.builder.actions';


const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.up(1028 + theme.spacing(1) * 3 * 2)]: {
      width: 1028,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  }
});

const pack = data.KS;

class App extends Component {
  buildPack = (pack) => {
    this.props.selectBasePack(pack);
    window.scroll({top: this.packBuilderRef.offsetTop, left: 0, behavior: 'smooth'});
  }

  render(){ 
    const { classes, packBuilder, selectBaseOption, selectAddOn, removeBasePack, removeBaseOption, removeAddOn } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <Fragment>
          <CssBaseline />
          <AppAppBar/>
          <main className={classes.layout}>
            <HeroContent title={pack.packName} description={pack.shortDescription} />
            <Grid container spacing={4} alignItems="flex-end">
              {pack.styles.map(style => (
                <Grid item key={style.name} xs={12} md={3}>
                  <PackCard 
                    pack={style} 
                    buildPack={this.buildPack} 
                    selectedBasePack={packBuilder.selectedBasePack}/>
                </Grid>
              ))}
            </Grid>
            <Grid container spacing={4} alignItems="flex-end">
              <PackDescription 
                images={pack.images} 
                title={pack.packName}
                description={pack.description}/>
            </Grid>
            <hr ref={(ref)=> {this.packBuilderRef=ref}}/>
            <PackBuilder 
              packData={pack}
              packBuilder={packBuilder} 
              selectBaseOption={selectBaseOption}
              selectAddOn={selectAddOn}
              removeBasePack={removeBasePack}
              removeBaseOption={removeBaseOption}
              removeAddOn={removeAddOn}
              />
          </main>
        </Fragment>
      </MuiThemeProvider>
    )
  }
}

const mapStateToProps = state => ({
  ...state
})

const mapDispatchToProps = {
  selectBasePack,
  selectBaseOption, 
  selectAddOn, 
  removeBasePack, 
  removeBaseOption, 
  removeAddOn
}
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(App));